import { Injectable, InjectionToken } from '@angular/core';
import { Infoblock, OccInfoblocksResponse } from '@main/infoblock/const';
import { SnackTheme } from '@main/snackbar/const';
import { Converter } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class OccInfoblockNormalizer implements Converter<OccInfoblocksResponse, Infoblock[]> {
  convert(source: OccInfoblocksResponse, target?: Infoblock[]): Infoblock[] {
    if (target === undefined) {
      target = [...source.infoblocks] as any;
    }

    target = source.infoblocks.map((infoblock) => ({
      ...infoblock,
      theme: infoblock.theme.toLowerCase() as SnackTheme,
      // дата приходит с локальным значением, но типа по гринвичу.
      // условно 2022-09-26T14:40:00+0000, где + 0000 это сколько прибавлять в зависимости от пояса(тут ноль)
      // поэтому, мы сначал отпиливаем указание пояса, а затем создаем дату от первой части, получая переданное время как локальное
      // выглядит надежно)
      endTime: new Date(infoblock.endTime.split('+')[0]),
      startTime: new Date(infoblock.startTime.split('+')[0]),
    }));

    return target;
  }
}

export const INFOBLOCK_NORMALIZER = new InjectionToken<OccInfoblockNormalizer>('InfoblockResponseNormalizer');
